import { render } from "./SearchField.vue?vue&type=template&id=cb0fc4bc"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"

import "./SearchField.vue?vue&type=style&index=0&id=cb0fc4bc&lang=scss"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__